import axios from '../../../../utils/axios';
import { Alert, Anchor, Button, Checkbox, ColorScheme, Container, Drawer, Group, ScrollArea, Stack, Table, Tabs, TextInput, Title, useMantineColorScheme, useMantineTheme } from '@mantine/core';
import { useLocalStorage, useViewportSize } from '@mantine/hooks';
import { PlusCircle } from 'lucide-react';
import { useContext, useEffect, useRef, useState } from 'react';
import defaultAxios from "axios";
import EditorContainer from '../../../../sections/EditorContainer';
import { AuthContext } from '../../../../contexts/Auth/Auth.Context';

function ArticlesItems(){
        const { state } = useContext(AuthContext);

        const [news, setNews] = useState([]);

        const [precedents, setPrecedents] = useState([]);

        const [open, setOpen] = useState(false);

        const [title, setTitle] = useState("");

        const [colorScheme, ] = useLocalStorage<ColorScheme>({
            key: 'color-scheme',
            defaultValue: 'light', // 'light' or 'dark'
            getInitialValueInEffect: true,
        });

        const [loading, setLoading] = useState(false);

        const [htmlContent, setHtmlContent] = useState(""); // Store the HTML content for preview
        
          const editorRef = useRef<{ clearEditor: () => void }>(null); // Reference to EditorContainer

        const { width, height } = useViewportSize();

    
        useEffect(() => {
            axios.get("/news/all").then(function(res){
                if(res.status === 200){
                    setNews(res.data.data)
                }
            }).catch(function(err){
                console.log(err);
            })
        }, []);

        useEffect(() => {
            axios.get("/precedents/all").then(function(res){
                if(res.status === 200){
                    setPrecedents(res.data.data);
                }
            }).catch(function(err){
                console.log(err);
            })
        }, []);

        const handlePublish = () => {
            try{
                setLoading(true);

                const body = {
                    title: title,
                    content: htmlContent,
                    author: state.userData?.name
                };

                axios.post("/precedents/create", body).then(function(res){
                    if(res.status === 200){
                        window.location.reload();
                    }
                }).catch(function(err){
                    console.log(err);
                    setLoading(false);
                    alert("An issue occured while submitting data")
                })
            } catch(err){
                console.error(err);
            }
        }
    return (
        <>
            <Tabs defaultValue="inTheNews" color='green'>
              <Tabs.List>
                <Tabs.Tab value="inTheNews">In the News</Tabs.Tab>
                <Tabs.Tab value="casePrecedents">Case Precedents</Tabs.Tab>
              </Tabs.List>

              <Tabs.Panel value="casePrecedents" pt="xs">
                <Container size={width * 0.75} h={height * 0.7}>
                <Group mb={10} position='right'>
                    <Button onClick={() => {setOpen(true)}} leftIcon={<PlusCircle />} >Publish New Case Precedent</Button>
                </Group>
                <div style={{ overflowX: "auto", overflowY: "auto"}} className='overflow-x-auto'>
                <Table withBorder withColumnBorders striped highlightOnHover fontSize={"xs"} verticalSpacing="xs" horizontalSpacing="xs" style={{width: "100%"}}>
                    <thead>
                        <tr>
                        <th>#</th>
                        <th>
                            <Checkbox />
                        </th>
                        <th style={{ whiteSpace: 'nowrap' }}>Title</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Summary</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {precedents.length === 0 ? (
                            <tr>
                                <td colSpan={5} style={{textAlign: "center"}}>No case precedents found</td>
                              
                            </tr>
                        ) : (
                            precedents.map((itm: any, idx: number) => {
                                return (
                                    <tr key={idx}>
                                        <td>
                                            {idx + 1}
                                        </td>
                                        <td>
                                            <Checkbox />
                                        </td>
                                        <td>
                                            {itm?.title}
                                        </td>
                                        <td>
                                            <div style={{ height: "150px", overflowY: "auto", width: width * 0.4 }}>
                                                <div dangerouslySetInnerHTML={{ __html: itm.content }} />
                                            </div>
                                        </td>
                                        <td>
                                            <Group noWrap>
                                                <Button size='xs'>Edit</Button>
                                                <Button size='xs' color="red">Trash</Button>
                                            </Group>
                                        </td>
                                    </tr>
                                )
                            })
                        )}
                    </tbody>
                </Table>
                </div>
                </Container>
              </Tabs.Panel>

              <Tabs.Panel value="inTheNews" pt="xs">
                <Container size={width * 0.75}>
                <div style={{ overflowX: "auto", overflowY: "auto", height: "70vh"}} className='overflow-x-auto'>
                <Table withBorder withColumnBorders fontSize={"xs"} verticalSpacing="xs" horizontalSpacing="xs" style={{width: "100%"}}>
                    <thead>
                        <tr>
                        <th>#</th>
                        <th>
                            <Checkbox />
                        </th>
                        <th style={{ whiteSpace: 'nowrap' }}>Author</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Title</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Description</th>
                        <th style={{ whiteSpace: 'nowrap' }}>URL</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Feature Image</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Published At</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Summary</th>
                        </tr>
                    </thead>
                    <tbody>
                        {news.length === 0 ? (
                                                    <tr>
                            <td colSpan={9} style={{textAlign: "center"}}>No articles in the news</td>
                              
                        </tr>
                        ) : (
                            news.map((itm: any, idx: number) => {
                                return (
                                    <tr key={idx}>
                                        <td>{idx+1}</td>
                                        <td>
                                            <Checkbox />
                                        </td>
                                        <td>
                                            {itm?.author || "N/A"}
                                        </td>
                                        <td>
                                            {itm?.title || "N/A"}
                                        </td>
                                        <td>
                                            {itm?.description || "N/A"}
                                        </td>
                                        <td>
                                            <Anchor href={itm?.url || "#"}>Link</Anchor>
                                        </td>
                                        <td>
                                            <Anchor href={itm?.urlToImage || "#"}>Link</Anchor>
                                        </td>
                                        <td>
                                            {itm?.publishedAt || "N/A"}
                                        </td>
                                        <td>
                                            {itm?.content || "N/A"}
                                        </td>
                                    </tr>
                                )
                            })
                        )}
                        </tbody>
                </Table>    
                </div>
                </Container>
                </Tabs.Panel>
            </Tabs>
        <Drawer position="right" padding={"md"} size={width * 0.7} withCloseButton={false} opened={open} onClose={() => {setOpen(false)}}>
            <Stack h={height * 0.9}>
                <div>
                
                    <Title mb="md" order={5}>Publish New Case Precedent</Title>

                    <TextInput value={title} onChange={(e) => {setTitle(e.currentTarget.value)}} label="Title" mb="md" required />
                <ScrollArea h={height * 0.7}>
                    <EditorContainer
                        ref={editorRef}
                        theme={colorScheme} // Use the theme variable here
                        onContentChange={(content) => setHtmlContent(content)} // Capture HTML content
                    />
                </ScrollArea>
                </div>

                <Group mt={20}>
                    <Button onClick={() => {setOpen(false)}} variant='default'>Cancel</Button>
                    <Button loading={loading} onClick={() => {handlePublish()}} >Publish</Button>
                </Group>
            </Stack>
        </Drawer>
            </>
    )
}

export default function Articles() {
    return (
        <div className="space-y-8 p-6">
            <Alert title="Articles" color="green">
            This section allows you to manage articles(e.g case precedents), including adding, removing, and updating article information. Additionally, all scrapped news from the internet will be listed here for easy management and access.
        </Alert>
            <section>
            <ArticlesItems />
            </section>
        </div>
    )
}